<template>
    <div>
        <loader-component v-if="isSendingDataToServer"></loader-component>
        <loader-component v-if="showLoader"></loader-component>
      
        <div v-else class="wrapper default shopping-page">
            <selected-cart-modal></selected-cart-modal>
            <responsive-header-component></responsive-header-component>
            <!-- responsive-header -->
            <!-- header -->
            <header class="main-header default">
                <div class="container">
                    <header-component></header-component>
                </div>
                <navbar3-component></navbar3-component>
            </header>
            <!-- header -->
            <!-- header-shopping -->
            <!-- main-shopping -->
            <main class="cart-page default">
                <div class="container">
                    <div class="row">

                        <div class="cart-page-content col-xl-12 col-lg-12 col-md-12 ">
                            <div class="row">
                                <div class="info-main-top col-xl-6 col-lg-6 col-md-6 col-xs-12 td-r">
                                    <span class="title f-s-13">کد رهگیری پستی : </span>
                                    <span class="text td-r"> {{order.PostalTrackingCode}} </span>
                                    <br />
                                    <span class="title d-none d-sm-inline-block f-s-13">شماره سفارش : </span>
                                    <span class="title d-none d-sm-inline-block text td-r f-size-12"> {{order.InvoiceNo}} </span>
                                    <!--<span class="title f-s-13"> شماره رهگیری بانکی: </span>
                            <span class="text td-r"> {{order.BankTrackingNo}} </span>-->
                                </div>
                                <div class="info-main-top col-xl-6 col-lg-6 col-md-6 col-xs-12 td-r">


                                    <span class="title f-s-13"> تاریخ و زمان ثبت : </span>
                                    <span class="text td-r"> {{order.OrderRegDateTime}} </span>
                                </div>
                            </div>
                            <hr />

                            <section class="page-content tracking default col-xl-12 col-lg-12 col-md-12">
                                <div class="content-p col-xl-12 col-lg-12 col-md-12">
                                    <div class="title-showInvoice  td-r">
                                        <p class="title">وضیعت سفارش</p>
                                    </div>
                                    <ul v-if="order.LastOrderStatusTypeId != 3">
                                        <li :class="['step1','left-l',(order.LastOrderStatusTypeId >= 1 || order.LastOrderStatusTypeId >= 2)? 'done':'']">
                                            <span class="icon"></span>
                                            <span class="title f-s-13 f-f-j">آماده سازی سفارش</span>
                                        </li>
                                        <!--<li :class="['progress',(order.LastOrderStatusTypeId >= 1 || order.LastOrderStatusTypeId >= 2)? 'done':'']">
                                </li>-->
                                        <!--<li :class="['step2','left-l',(order.LastOrderStatusTypeId >= 2)? 'done':'']">
                                    <span class="icon"></span>
                                    <span class="title f-s-13">تایید سفارش</span>
                                </li>-->
                                        <li :class="['progress','left-l',(order.LastOrderStatusTypeId >= 1 || order.LastOrderStatusTypeId >= 2 || order.LastOrderStatusTypeId >= 4)? 'done':'']">
                                        </li>
                                        <li :class="['step4','left-l',(order.LastOrderStatusTypeId >= 4)? 'done':'']">
                                            <span class="icon"></span>
                                            <span class="title f-s-13 f-f-j">تحویل به پیک</span>
                                        </li>
                                        <li :class="['progress',(order.LastOrderStatusTypeId >= 5)? 'done':'']">
                                        </li>
                                        <li :class="['step3','left-l' ,(order.LastOrderStatusTypeId >= 5)? 'done':'']">
                                            <span class="icon"></span>
                                            <span class="title f-s-13 f-f-j">تحویل به مشتری</span>
                                        </li>

                                    </ul>
                                    <ul v-else>
                                        <li style="width:100%">
                                            <div class="warning-checkout text-center default col-xl-12 col-lg-12 col-md-12">
                                                <div class="icon-warning">
                                                    <img src="/assets/img/step/rejectOrder.svg" alt="سفارش شما توسط فروشگاه رد شده است" title="سفارش شما توسط فروشگاه رد شده است" />
                                                </div>
                                                <h1 class="f-s-13">سفارش شما توسط فروشگاه رد شده است.</h1>
                                                <p></p>
                                            </div>
                                        </li>
                                    </ul>
                                    <!--<div class="preparreduration-main" v-if="order.PrepareDuration != null && order.LastOrderStatusTypeId != 5 && order.LastOrderStatusTypeId != 1">
                                <div class="content"><span class="title f-s-13">زمان تقریبی تحویل سفارش :</span> <span> {{order.PrepareDuration}} روز </span> <span></span></div>
                            </div>-->
                                    <div class="preparreduration-main" v-if="order.LastOrderStatusTypeId == 1">
                                        <div class="content"><span class="title f-s-13">سفارش ثبت و در حال بررسی می باشد.</span></div>
                                    </div>
                                    <div class="preparreduration-main" v-if="order.LastOrderStatusTypeId == 5">
                                        <div class="content"><span class="title f-s-13">سفارش شما تحویل داده شده است.</span></div>
                                    </div>
                                </div>
                            </section>
                            <section class="table-content col-xl-12 col-lg-12 col-md-12  d-none d-sm-block">
                                <div class="toman"><i class="now-ui-icons travel_info "></i> <span class="  f-s-13"> توجه : </span> <span class="f-s-13  ">  قیمت ها به تومان می باشد.</span></div>
                                <div class="table-responsive">
                                    <table class="table table-hover table-striped">
                                        <thead>
                                            <tr>
                                                <th style="width:25px" scope="col">ردیف</th>
                                                <!--<th scope="col">کد کالا</th>-->
                                                <th scope="col">تصویر</th>
                                                <th scope="col">نام محصول</th>
                                                <!--<th scope="col">واحد</th>-->
                                                <th scope="col">تعداد </th>
                                                <!--<th scope="col">قیمت کل</th>-->
                                                <th scope="col">قیمت واحد</th>
                                                <th scope="col">مبلغ تخفیف</th>
                                                <th scope="col">قیمت نهایی</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(orderDetails ,index) in order.OrderDetails">
                                                <th scope="row">{{index + 1}}</th>
                                                <!--<th scope="row">{{orderDetails.Code}}</th>-->
                                                <th scope="row"><img class="img-circle-td" :src="orderDetails.PicPath" /></th>
                                                <td>
                                                    <router-link class="btn-link-product" :title="orderDetails.ProductName" :to="{ name: 'product' , params: { productId: orderDetails.ProductId , productName: orderDetails.ProductName.replace(/\s+/g, '-') } }">
                                                        {{orderDetails.ProductName}} <br /> <span class="code-tr"> کد کالا : {{orderDetails.ProductId}}</span>
                                                    </router-link>
                                                </td>
                                                <!--<td>{{orderDetails.ProductUnit}}</td>-->
                                                <td>{{orderDetails.Quantity}}</td>
                                                <!--<td>{{orderDetails.Quantity * orderDetails.Price | formatNumber}}</td>-->
                                                <td>{{orderDetails.Price | formatNumber}}</td>
                                                <td>{{(orderDetails.Quantity * orderDetails.Price) - orderDetails.FinalPriceSum | formatNumber}}</td>
                                                <td>{{orderDetails.FinalPriceSum | formatNumber}}</td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </section>
                            <section class="table-content tbl-kharid col-xl-12 col-lg-12 col-md-12  d-block d-sm-none xs-tbl-n-t">
                                <div class="toman"><i class="now-ui-icons travel_info "></i> <span class="  f-s-13"> توجه : </span> <span class="f-s-13">  قیمت ها به تومان می باشد.</span></div>

                                <table class="table table-hover table-striped">

                                    <tbody>
                                        <tr v-for="(orderDetails ,index) in order.OrderDetails">
                                            <!--<td scope="row">
                                        <div class="flex">
                                            <div class="tlt-tbl bold-500">ردیف</div>
                                            <div class="txt-tbl">{{index + 1}}</div>
                                        </div>
                                    </td>-->
                                            <td>
                                                <div class="flex">
                                                    <div class="tlt-tbl bold-500">تصویر</div>
                                                    <div class="txt-tbl"><img class="img-circle-td" :src="orderDetails.PicPath" /></div>
                                                </div>
                                            </td>

                                            <td>
                                                <div class="flex">
                                                    <div class="tlt-tbl bold-500">نام محصول <br /><span class="code-tr"> کد کالا : {{orderDetails.ProductId}}</span></div>
                                                    <div class="txt-tbl" style="text-align:center">
                                                        <router-link tag="a" class="center f-size-12" :to="{ name: 'product' , params: { productId: orderDetails.ProductId , productName: orderDetails.ProductName.replace(/\s+/g, '-') } }">{{ orderDetails.ProductName }}</router-link>
                                                    </div>
                                                </div>
                                            </td>
                                            <!--<td>
                                        <div class="flex">
                                            <div class="tlt-tbl bold-500">واحد</div>
                                            <div class="txt-tbl">{{orderDetails.ProductUnit}}</div>
                                        </div>
                                    </td>-->
                                            <td>
                                                <div class="flex">
                                                    <div class="tlt-tbl bold-500">تعداد</div>
                                                    <div class="txt-tbl"> {{orderDetails.Quantity}}</div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="flex">
                                                    <div class="tlt-tbl bold-500">قیمت واحد</div>
                                                    <div class="txt-tbl">{{orderDetails.Quantity * orderDetails.Price | formatNumber}}</div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="flex">
                                                    <div class="tlt-tbl bold-500">مبلغ تخفیف</div>
                                                    <div class="txt-tbl">
                                                        {{(orderDetails.Quantity * orderDetails.Price) - orderDetails.FinalPriceSum | formatNumber}}
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="flex">
                                                    <div class="tlt-tbl bold-500">قیمت نهایی</div>
                                                    <div class="txt-tbl">{{orderDetails.FinalPriceSum | formatNumber}}</div>
                                                </div>
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>

                            </section>
                            <hr />
                            <section class="cart-summery col-xl-12 col-lg-12 col-sm-12 col-md-12">
                                <div class="row main-cartsummery">
                                    <div class="col-12 p-f-0 info-main-b col-xl-4 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <div class="main-box">
                                            <span class="title tlt-box"> خلاصه خرید : </span>
                                            <span class="text txt-box"> {{order.CountOfProducts}} کالا</span>
                                        </div>
                                        <div class="main-box">
                                            <span class="title tlt-box"> جمع مبلغ تخفیف : </span>
                                            <span class="text txt-box"> {{order.Discount | formatNumber }} تومان</span>
                                        </div>
                                        <div class="main-box">
                                            <span class="title tlt-box"> هزینه ارسال : </span>
                                            <span class="text txt-box"> {{order.DeliveryFee | formatNumber }} تومان</span>

                                        </div>

                                        <div class="main-box">
                                            <span class="title tlt-box"> قیمت کل : </span>
                                            <span class="text txt-box"> {{order.SubTotal | formatNumber }} تومان</span>

                                        </div>
                                        <div class="main-box">
                                            <span class="title tlt-box">  مبلغ پرداختی : </span>
                                            <span class="text txt-box"> {{order.InvoiceDue | formatNumber }} تومان</span>
                                        </div>

                                    </div>
                                    <div class="col-12 p-f-0 info-main-b col-xl-4 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <div class="main-box">
                                            <span class="title tlt-box">  نحوه ارسال : </span>
                                            <span class="text txt-box"> {{order.CarrierName }} </span>
                                        </div>
                                        <div class="main-box">
                                            <span class="title tlt-box"> روش پرداخت : </span>
                                            <span class="text txt-box"> پرداخت آنلاین </span>
                                        </div>

                                    </div>
                                </div>

                            </section>
                        </div>
                    </div>
                </div>

            </main>
            <!-- main-shopping -->
            <!-- footer -->
            <footer-component></footer-component>
            <!-- footer -->
        </div>
    </div>
</template>

<script>
    import { initialSite } from "../../module/initialSite"
    import { httpPromise } from "../../module/httpUtility";
    export default {
        data() {
            return {
                order: {},
                showLoader: false,
                isSendingDataToServer: false,
            }
        },

        beforeMount() {
            createPageTitle('وضیعت سفارش');
            initialSite(this);
            this.isSendingDataToServer = true;
            httpPromise(this, '/v1/Orders/Orders/Read', 'Get', { HashOrderId: this.$route.params.hashOrderId },
                response => {
                    toastr.remove();
                    this.order = response.data.Value;
                    this.isSendingDataToServer = false;
                },
                response => {
                    toastr.remove();
                    toastr.error(response.data.Message);
                    this.isSendingDataToServer = false;
                }
            );
        }
    }
</script>
<style scoped>
    .f-size-12 {

        font-size:12px;
    }
    .tbl-kharid td {
        padding-top: 5px;
        padding-bottom: 8px;
    }
    .main-box .tlt-box {
        text-align: center;
        padding: 8px 0 8px 0;
        display: inline-block;
        width: 35%;
        background-color: #fee;
        font-size: 14px;
        font-weight: bold;
        color: #6a6262;
        position: relative;
    }
    .main-box {
        margin-bottom:5px;
        border: 1px solid #f5c9c9;
        border-radius:5px;
        display: inline-block;
        width: 100%;
    }
      .main-box .tlt-box::after {
            content: '';
            position: absolute;
            left: -36px;
            top: 0px;
            width: 0;
            height: 0;
            border-left: 18px solid transparent;
            border-right: 18px solid #fee;
            border-top: 18px solid #fee;
            border-bottom: 18px solid #fee;
            clear: both;
        }
       .main-box .txt-box {
            text-align: center;
            padding: 10px;
            display: inline-block;
            width: 65%;
        }
    .btn-link-product {
        color: #B65454;
       
    }
    .btn-link-product:hover {
        color: #8e1717;
        cursor: pointer;
        transition:all .3s;
    }
    .img-circle-td {
    
        width:50px;
    }
    .code-tr {
        font-size: 12px;
        color: #aa9595;
        padding-right: 8px;
    }
    .red-color {
        color: #e45454;
    }
    .xs-tbl-n-t .bold-500 {
        font-weight: bold;
    }

    .xs-tbl-n-t .tlt-tbl {
        font-size:13px;
        width: 100%;
        text-align: right;
    }

    .xs-tbl-n-t .txt-tbl {
        width: 100%;
        text-align: right;
    }

    .xs-tbl-n-t tr, .xs-tbl-n-t td, .xs-tbl-n-t th {
        display: block;
    }



    .title-showInvoice {
/*        margin-bottom: 50px;*/
    }

    .preparreduration-main .content {
        display: inline-block;
        padding: 7px 25px 7px 25px;
        border: 1px solid #ddd;
        border-radius: 7px;
        margin-top: 25px;
        margin-bottom: 30px;
    }

    .preparreduration-text {
    }

    .alarm {
        font-size: 17px;
    }

    .toman {
        text-align: center;
        margin-bottom: 7px;
    }

        .toman i {
            vertical-align: middle;
            font-size: 17px;
        }

    .main-cartsummery {
        border: 1px solid #ddd;
        border-radius: 7px;
        margin-bottom: 25px;
        padding: 15px
    }

    .info-main-b {
        padding: 10px;
    }

        .info-main-b .text {
            color: #888;
        }

        .info-main-b .title {
            color: #666;
            font-size: 14px;
        }
    .info-main-b {
        font-size:13px;
    }
            .info-main-top .text {
        color: #888;
    }

    .title-showInvoice {
        padding-right: 15px;
    }

    .info-main-top {
        padding: 10px 25px 0px 25px;
        text-align: center;
    }

    .table thead tr {
        background-color: #85b3be;
        border: 1px solid #85b3be;
        color: #fff;
    }

    .shopping-page header.header-shopping .checkout-steps li a {
        display: inline-block;
        height: 39px;
    }

    .cart-page .checkout-aside {
        margin-top: 20px;
        margin-bottom: 83px;
        background-color: #fff;
    }

    .cart-page-content {
        background-color: #fff;
        margin-top: 20px;
    }

    .content-p {
        text-align: center;
    }

    .done {
    }

    .step1 {
    }

    .tracking {
        height: 250px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

        .tracking ul li .icon {
            display: block;
            height: 50px;
            width: 70px;
            margin: 0 auto;
            position: relative;
            padding: 0 10px;
            z-index: 100;
        }
        .tracking ul {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
        }
       
        .tracking ul li {
          margin-top:20px;
        }

            .tracking ul li.progress {
                border-top: 2px solid #cecece;
                border-top-color: rgb(206, 206, 206);
                border-radius: 0;
                background-color: #fff;
                height: 35px;
                width: 10%;
                margin-top: 50px;
            }

                .tracking ul li.progress.done {
                    border-color: #12b65c;
                }

            .tracking ul li.step1.done .icon {
                background: #fff url("/assets/img/step/track-step1h.svg") no-repeat center center;
            }

            .tracking ul li.step1 .icon {
                background: #fff url("/assets/img/step/track-step1.svg") no-repeat center center;
            }

            .tracking ul li.step2.done .icon {
                background: #fff url("/assets/img/step/track-step2h.svg") no-repeat center center;
            }

            .tracking ul li.step2 .icon {
                background: #fff url("/assets/img/step/track-step2.svg") no-repeat center center;
            }

            .tracking ul li.step3.done .icon {
                background: #fff url("/assets/img/step/track-step3h.svg") no-repeat center center;
            }

            .tracking ul li.step3 .icon {
                background: #fff url("/assets/img/step/track-step3.svg") no-repeat center center;
            }

            .tracking ul li.step4.done .icon {
                background: #fff url("/assets/img/step/track-step4h.svg") no-repeat center center;
            }

            .tracking ul li.step4 .icon {
                background: #fff url("/assets/img/step/track-step4.svg") no-repeat center center;
            }
    @media only screen and (min-width: 0px) and (max-width: 768px) {
        .p-f-0 {
            padding-top: 0;
            padding-bottom: 0;
        }

    }
        @media only screen and (min-width: 0px) and (max-width: 640px) {
           
            .f-f-j {
                font-size: 12px;
            }

            .left-l {
                padding-left: 0;
            }

            .tracking ul {
                flex-wrap: unset;
            }

            .main-box .tlt-box {
                font-size: 12px;
            }

            .main-box .txt-box {
                padding: 8px;
                font-size: 11px;
            }

            .main-box .tlt-box::after {
                left: -32px;
                border-left: 17px solid transparent;
                border-right: 17px solid #fee;
                border-top: 17px solid #fee;
                border-bottom: 17px solid #fee;
            }

           /* .shopping-page main.cart-page {
                margin-top: 125px;
            }
*/
            .td-r {
                text-align: right;
            }

            .info-main-top {
                padding: 10px 25px 0px 25px;
            }

            .success-checkout h1, .warning-checkout h1, .preparreduration-main .content {
                font-size: 12px;
            }

            .shopping-page header.header-shopping .checkout-steps li a.active::after {
                bottom: -23px;
            }

            /* .tracking ul li.progress {
            display: none;
            visibility: hidden;
        }*/

            .right-r {
                padding-right: 20px;
            }

            .tracking ul li.progress {
                width: 15%;
            }
            /* .left-l {
            padding-left: 20px;
        }*/

            .tracking {
          /*      margin-top: 65px;*/
                margin-bottom: 0px;
            }
        }

        @media only screen and (min-width: 640px) and (max-width: 767px) {
            .td-r {
                text-align: right;
            }
        }

        @media only screen and (min-width: 640px) and (max-width: 1077px) {
           /* .shopping-page main.cart-page {
                margin-top: 125px;
            }*/
        }
</style>